import styled from 'styled-components';
import {
    mobileMedia,
    tabletMedia,
} from '../../../globalVariables/GlobalVariables';
import {btn} from '../../../component/button/btn/Btn.css';
import {dFlexColumnCenter} from '../../../globalVariables/GlobalFlex';

export const container = styled.div`
  ${dFlexColumnCenter}
  width: 100%;
  margin: 0 auto;
  gap: 32px;
  
${btn}{
  height: 50px;
  min-width: 152px;
  font-size: 18px;
  font-weight: 700;
}
`;

export const image = styled.img`
  width: 30%;
`;

export const description = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  max-width: 40%;

  ${tabletMedia} {
    font-size: 15px;
  }
  ${mobileMedia} {
    font-size: 14px;
  }
`;